const verificationStatusIds = {
  InProcess: 1,
  Error: 2,
  Completed: 3,
  CompletedWithErrors: 4
};

export default verificationStatusIds;
